import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import { Stack, CenterContainer, Box, Separator } from '../../components/containers';
import { ButtonRounded, Button } from '../../components/actions';
import { ErrorBox, Headline } from '../../components/text';
import { Input } from '../../components/fields';
import { PAGE_GENERAL } from '../../App';
import s from './index.css';

const FORGOTTEN_STATUS = {
    None: 0,
    Sending: 1,
    Error: -1,
};

class RequestPasswordPageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: FORGOTTEN_STATUS.None,
            username: '',
        };
    }

    render() {
        return (
            <CenterContainer>
                <Box className={s.container} addPadding={true}>
                    <form onSubmit={this.handleFormSubmit}>
                        <Headline size="small">Password forgotten</Headline>

                        <ErrorBox hide={this.state.status >= 0} label="No such account exists, try again" />

                        <Input
                            tabIndex={1}
                            placeholder="Username"
                            value={this.state.username}
                            onChange={this.handleUsernameChange}
                        />

                        <Separator type="huge" />

                        <Stack>
                            <ButtonRounded
                                onClick={this.goToLoginForm}
                                type="button"
                                tabIndex={3}
                                align="left"
                                label="Back to login page"
                            />

                            <Button
                                type="submit"
                                withBox={true}
                                align="right"
                                tabIndex={2}
                                isLoading={this.state.status === FORGOTTEN_STATUS.Sending}
                                label={
                                    'Recovering password is disabled'
                                    /*
                                    this.state.status === FORGOTTEN_STATUS.Sending
                                        ? 'Sending email'
                                        : 'Send me new password'
                                    */
                                }
                            />
                        </Stack>
                    </form>
                </Box>
            </CenterContainer>
        );
    }

    handleUsernameChange = e => {
        this.setState({
            username: e.target.value,
        });
    };

    handleFormSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        return;
    };

    goToLoginForm = e => {
        e.preventDefault();
        this.props.dispatch(push(PAGE_GENERAL.Login));
    };
}

export default connect()(RequestPasswordPageContainer);



// WEBPACK FOOTER //
// ./app/web/src/container/PasswordForgottenPage/index.jsx